import classnames from 'classnames/bind'
import React, { useRef, useState } from 'react'

import Slider, { useSliderState } from '@unlikelystudio/react-slider'

import SliderArrow from '~/components/EditoSliderImages/SliderArrow'
import SliderBullets from '~/components/EditoSliderImages/SliderBullets'
import SliderImage from '~/components/EditoSliderImages/SliderImage'
import RichText from '~/components/RichText'

import { useStyle } from '~/providers/StyleProvider'

import Ratio from '../Ratio'
import css from './styles.module.scss'
import { EditoSliderImagesProps, EditoSliderState } from './types'

const cx = classnames.bind(css)

function EditoSliderImages({
  className,
  title,
  items,
}: EditoSliderImagesProps) {
  const gridStyle = useStyle({ grid: 'base-grid' })
  const titleStyle = useStyle({ textPreset: 'title-content-page' })
  const textStyle = useStyle({ textPreset: 'text-paragraph', color: 'ebony' })
  const customSliderRef = useRef()
  const [{ nextSlide, prevSlide, slideIndex }, setSliderState] =
    useSliderState()

  const slidesAmount = items?.length

  return (
    <div className={cx(css.EditoSliderImages, className)} ref={customSliderRef}>
      <div className={cx(gridStyle, css.content)}>
        {title && (
          <RichText className={cx(css.title, titleStyle)} render={title} />
        )}
      </div>
      <div className={css.sliderContent}>
        {items?.length > 0 && (
          <>
            <div className={css.sliderControls}>
              <SliderArrow
                className={css.sliderControlsItem}
                onClick={prevSlide}
              />

              <SliderArrow
                right
                className={cx(css.sliderControlsItem, css.arrowRight)}
                onClick={nextSlide}
              />
            </div>
            <Slider
              className={css.slider}
              infinite
              snap
              setSliderState={setSliderState}
              customSliderRef={customSliderRef}>
              {items?.map((item, index) => {
                const isActive = slideIndex === index

                return (
                  <div className={cx(css.sliderItem)} key={index}>
                    <SliderImage
                      {...item}
                      isActive={isActive}
                      className={cx(css.sliderImage)}
                      key={`slider_image_${index}`}
                    />
                  </div>
                )
              })}
            </Slider>

            {items?.[slideIndex]?.text && (
              <div className={css.sliderImageText}>
                <RichText
                  className={cx(css.text, textStyle)}
                  render={items?.[slideIndex].text}
                />
              </div>
            )}

            <SliderBullets
              className={css.sliderBullets}
              currentSlideIndex={slideIndex}
              indexes={slidesAmount}
            />
          </>
        )}
      </div>
    </div>
  )
}

EditoSliderImages.defaultProps = {}

export default EditoSliderImages
